import type { VignetteDefinition } from "./types";

/**
 * The long arc's payoff — Johnny finally sails off on the raft he's been
 * building. Scoped deliberately for this pass: he doesn't actually
 * animate away along a path (no locomotion-to-a-target system exists yet
 * for that), but the dramatic wide pull-back plus the loop restart
 * (`onExit` resets LongArcState and hides the raft, so it has to be built
 * again next time around) delivers the concept's cyclical-restart feel
 * without needing that system built first. Revisit once/if Johnny gets
 * general point-to-point movement.
 */
export const escapeEndingVignette: VignetteDefinition = {
  id: "escape-ending",
  name: "Escape at last",
  category: "rare",
  weight: 1,
  animationClip: "Wave",
  loopAnimation: true,
  durationMs: 7000,
  cameraFraming: {
    offset: { x: 10, y: 6, z: 10 },
    targetOffset: { x: 0, y: 2, z: 0 },
  },
  audioCues: [],
  minSimDay: 3,
  onExit: (ctx) => {
    ctx.decorator.setRaftVisible(false);
    ctx.longArcState.reset();
  },
};
